import PropTypes from 'prop-types'
import sortBy from 'lodash/sortBy'

import ColorCircle from 'components/Shared/ColorCircle/Index'
import FilterList from 'components/Shared/FilterList/Index'

const StatusesFilter = ({
  partnerStatuses, activeStatusFilters, onChange, isTicketFiltersFetching,
}) => {
  const getStatusesOptions = () => {
    let options = []
    partnerStatuses.forEach((status) => {
      options.push({
        value: status.name,
        label: status.name,
        color: status.color,
        bgColor: status.color,
      })
    })

    options = sortBy(options, ['label'])
    return options
  }

  const getIconComponentsMap = () => {
    const iconComponentsMap = {}
    partnerStatuses.forEach((status) => {
      iconComponentsMap[status.name] = <ColorCircle color={status.color} />
    })
    return iconComponentsMap
  }

  const onFilterChange = (filter) => {
    onChange(filter.value)
  }

  const filterSectionsDesc = [{
    name: 'statuses',
    title: 'Statuses',
    type: 'statuses',
    options: getStatusesOptions(),
    iconComponentsMap: getIconComponentsMap(),
  }]

  return (
    <FilterList
      activeFilters={{ statuses: activeStatusFilters }}
      onFilterChange={onFilterChange}
      filterSectionsDesc={filterSectionsDesc}
    />
  )
}

StatusesFilter.propTypes = {
  partnerStatuses: PropTypes.array.isRequired,
  activeStatusFilters: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  isTicketFiltersFetching: PropTypes.bool,
}

export default StatusesFilter
